var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('section',[_c('vue-markdown',{attrs:{"id":"markdown-area","source":_vm.$props.summary}})],1)])}
var staticRenderFns = []

export { render, staticRenderFns }